import { useEffect, useState } from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import WalletBalancesContainer from "./WalletBalancesContainer";
import TransactionsContainer from "./TransactionsContainer";
import SectionTitle from "components/text/SectionTitle";
import MessageBox from "components/other/MessageBox";
import CashTransactionsContainer from "./CashTransactionsContainer";
import BillingHistoryContainer from "./BillingHistoryContainer";
import FastStartBonusContainer from "./FastStartBonusContainer";

const Wallet = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  const UserProperties = createSelector(
    (state) => state.User,
    (user) => ({
      profileData: user.profileData,
    })
  );

  const { profileData } = useSelector(UserProperties);

  // set page Title
  useEffect(() => {
    document.title = "Wallet | Scalelup";
  }, []);

  const [searchParams] = useSearchParams();

  const [successBox, setSuccessBox] = useState(false);
  const [paypalApprovedBox, setPaypalApprovedBox] = useState(false);

  useEffect(() => {
    const success = searchParams.get("success") === "true";
    if (success) setSuccessBox(true);

    const paypalApproved = searchParams.get("paypalApproved") === "true";
    if (paypalApproved) setPaypalApprovedBox(true);
  }, []);

  const closeMessageBox = () => {
    setSuccessBox(false);
    setPaypalApprovedBox(false);
  };

  let successMessage =
    "We have successfully processed your payment and credited coins to your account.";

  if (searchParams.get("provider") === "paypal")
    successMessage +=
      "  The receipt for your purchase has been emailed to you. Log into your PayPal account to view transaction details.";

  let fastStartBonus = false;

  if (profileData.fastStartBonus) {
    const now = new Date();
    const bonusExpires = new Date(profileData.fastStartBonus);

    if (bonusExpires.getTime() > now.getTime()) {
      fastStartBonus = true;
    }
  }

  return (
    <Layout>
      <Wallet>
        <PageTitle>Wallet</PageTitle>
        {successBox && (
          <MessageBox
            title="Payment Received"
            text={successMessage}
            closeBox={closeMessageBox}
            margin="0 0 24px 0"
          />
        )}
        {paypalApprovedBox && (
          <MessageBox
            title="Processing Payment"
            text="Your PayPal payment is currently being processed. Once we receive confirmation of the payment, the coins will be credited to your account. This may take a few seconds. The receipt for your purchase will be emailed to you."
            closeBox={closeMessageBox}
            margin="0 0 24px 0"
          />
        )}
        <WalletBalancesContainer />
        {fastStartBonus && <FastStartBonusContainer />}
        <SectionTitle>Coins Transactions</SectionTitle>
        <TransactionsContainer />
        <SectionTitle>Cash Transactions</SectionTitle>
        <CashTransactionsContainer />
        <SectionTitle>Billing History</SectionTitle>
        <BillingHistoryContainer />
      </Wallet>
    </Layout>
  );
};
